import React from 'react';
import { motion } from 'framer-motion';
import { PlayCircleIcon, RepeatIcon, ClockIcon } from 'lucide-react';
import { TemplatesCarousel } from './TemplatesCarousel';
import { IMAGES } from '../data/content';
const classFeatures = [{
  icon: PlayCircleIcon,
  label: 'Cada técnica explicada en video'
}, {
  icon: RepeatIcon,
  label: 'Repite las clases todas las veces que quieras'
}, {
  icon: ClockIcon,
  label: 'Avanza a tu propio ritmo, sin horarios'
}];
function Tag({
  children
}: {
  children: React.ReactNode;
}) {
  return <span className="inline-block bg-fil-terra text-white text-[10px] font-bold uppercase tracking-[0.14em] px-3 py-1.5 rounded-full" data-id="element-98" data-mp="1uy6uj80k4fie">
      {children}
    </span>;
}
export function IncludesSection() {
  return <section className="bg-fil-card px-4 sm:px-6 lg:px-8 py-12 sm:py-16" data-id="element-99" data-mp="1l3ewk332bqn3">
      <div className="max-w-5xl mx-auto" data-id="element-100" data-mp="3kdn3amakjz7r">
        <div className="text-center max-w-2xl mx-auto mb-10 sm:mb-14" data-id="element-101" data-mp="3kcbz4ld7opg4">
          <span className="inline-block text-[10px] sm:text-xs font-bold uppercase tracking-[0.14em] text-fil-terra-dark mb-4" data-id="element-102" data-mp="3fg4s0p92x7wl">
            Un solo acceso · Todo incluido
          </span>
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-fil-text leading-tight mb-4" data-id="element-103" data-mp="2dr4n2t79aoy">
            Todo lo que incluye El Arte de la Filigrana
          </h2>
          <p className="text-base sm:text-lg text-fil-taupe" data-id="element-104" data-mp="3ph5n388o6fcc">
            Recibe todo lo necesario para aprender, practicar y comenzar a
            crear tus propios proyectos.
          </p>
        </div>

        <div className="space-y-6 sm:space-y-8" data-id="element-105" data-mp="m18c4x2op3cy">
          <motion.article initial={{
          opacity: 0,
          y: 14
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.28,
          ease: [0.23, 1, 0.32, 1]
        }} className="bg-fil-bg rounded-[1.75rem] border border-fil-beige p-6 sm:p-8 grid sm:grid-cols-[0.8fr_1.2fr] gap-6 sm:gap-10 items-center" data-id="element-106" data-mp="m31h87xnffiu">
            <img src={IMAGES.portada} alt="Portada de la guía completa El Arte de la Filigrana" className="w-full max-w-[220px] mx-auto h-auto" data-id="element-107" data-mp="1enf0tfe58vt8" />
            <div data-id="element-108" data-mp="19pnb8s0z1ls7">
              <div className="flex items-center gap-3 mb-3" data-id="element-109" data-mp="19p5615wbzx85">
                <span className="font-serif text-2xl text-fil-terra font-bold" data-id="element-110" data-mp="14ohi4t3efwi5">
                  1
                </span>
                <Tag data-id="element-111" data-mp="10mvwojcsu9wc">Incluido</Tag>
              </div>
              <h3 className="text-xl sm:text-2xl font-bold text-fil-text leading-tight mb-3" data-id="element-112" data-mp="voavohpq3m6u">
                Guía completa El Arte de la Filigrana
              </h3>
              <p className="text-sm sm:text-base text-fil-text/75 leading-relaxed" data-id="element-113" data-mp="qvrhpjn4ip1i">
                Una guía visual y organizada paso a paso para aprender los
                fundamentos de la técnica y avanzar desde tus primeros rollos
                hasta composiciones completas.
              </p>
            </div>
          </motion.article>

          <motion.article initial={{
          opacity: 0,
          y: 14
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.28,
          ease: [0.23, 1, 0.32, 1]
        }} className="bg-fil-cocoa rounded-[1.75rem] p-6 sm:p-10 grid sm:grid-cols-[1.2fr_0.8fr] gap-6 sm:gap-10 items-center" data-id="element-114" data-mp="7ygly90padqt">
            <div data-id="element-115" data-mp="2xmmops0lk8qw">
              <img src={IMAGES.clasesGrabadas} alt="Clases grabadas paso a paso" className="w-full h-auto object-cover" style={{
              paddingTop: "10px",
              paddingBottom: "10px"
            }} data-id="element-116" data-mp="2xl1wwa5o33wq" /><div className="flex items-center gap-3 mb-3" data-id="element-117" data-mp="24yh3z59jmjr2">
                <span className="font-serif text-2xl text-fil-rose font-bold" data-id="element-118" data-mp="29wsezjbkr0av">
                  2
                </span>
                <span className="inline-block bg-white/20 text-white text-[10px] font-bold uppercase tracking-[0.14em] px-3 py-1.5 rounded-full" data-id="element-119" data-mp="2enij6t89kx3z">
                  Incluido
                </span>
              </div>
              <h3 className="text-xl sm:text-3xl font-bold text-white leading-tight mb-3" data-id="element-120" data-mp="1m5whq6ocncw8">
                Clases grabadas paso a paso
              </h3>
              <p className="text-sm sm:text-base text-white/80 leading-relaxed mb-6" data-id="element-121" data-mp="3juifrtm7dbac">
                Observa cada técnica en acción y sigue las explicaciones a tu
                propio ritmo. Puedes repetir cada clase todas las veces que
                necesites.
              </p>
              <ul className="space-y-3" data-id="element-122" data-mp="3stdkf19lmdbj">
                {classFeatures.map(feature => <li key={feature.label} className="flex items-center gap-3 bg-white/10 rounded-2xl px-4 py-3" data-id="element-123" data-mp="bd5f3d33h4m8">
                    <feature.icon size={20} className="text-fil-rose shrink-0" strokeWidth={1.75} data-id="element-124" data-mp="6fdmegumlegz" />
                    <span className="text-sm text-white/90 font-medium leading-snug" data-id="element-125" data-mp="kelp3jpzz4px">
                      {feature.label}
                    </span>
                  </li>)}
              </ul>
            </div>
            <div className="rounded-[1.5rem] overflow-hidden border border-white/20 shadow-lg" data-id="element-126" data-mp="2m8uk5axkmwzv">
              
            </div>
          </motion.article>

          <motion.article initial={{
          opacity: 0,
          y: 14
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.28,
          ease: [0.23, 1, 0.32, 1]
        }} className="bg-fil-rose-light rounded-[1.75rem] border border-fil-rose/30 p-6 sm:p-8" data-id="element-127" data-mp="282aqvndv4185">
            <div className="flex flex-wrap items-center gap-3 mb-3" data-id="element-128" data-mp="1odifltaxn0t1">
              <span className="font-serif text-2xl text-fil-terra font-bold" data-id="element-129" data-mp="1ofd0x8q48uxn">
                3
              </span>
              <Tag data-id="element-130" data-mp="1fck8v3940f6r">+150 diseños</Tag>
            </div>
            <h3 className="text-xl sm:text-2xl font-bold text-fil-text leading-tight mb-2" data-id="element-131" data-mp="1fdvlztog2zaj">
              Biblioteca de +150 plantillas
            </h3>
            <p className="text-sm sm:text-base text-fil-text/75 leading-relaxed mb-6 max-w-2xl" data-id="element-132" data-mp="39quxpbppf9cj">
              Una gran colección de diseños listos para utilizar en tus
              proyectos: flores, animales, mandalas y ocasiones especiales.
            </p>
            <TemplatesCarousel data-id="element-133" data-mp="3cccfyd5e3pyg" />
          </motion.article>
        </div>
      </div>
    </section>;
}